<script setup>
const props = defineProps(["class"]);
</script>

<template>
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		:class="class"
	>
		<path
			d="M4 10L8 6L12 10"
			stroke="currentColor"
			stroke-width="2"
			stroke-linecap="square"
		/>
	</svg>
</template>
